/**
 * Grow your practice server function: coach auth plus delegation to
 * `~/lib/server/cih/grow-practice`.
 *
 * Aliases: grow your practice api, practice stage reading list api
 */

import { createServerFn } from "@tanstack/react-start";

import { requireClerkCoachAuth } from "~/lib/coach-middleware";

/** The coach's Start Here playbooks and the pages for her practice stage. */
export const getGrowPractice = createServerFn({ method: "GET" })
  .middleware([requireClerkCoachAuth])
  .handler(async ({ context }) => {
    const { readGrowPractice } = await import("~/lib/server/cih/grow-practice");
    return readGrowPractice(context.coach.id);
  });
